import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, map, switchMap } from 'rxjs';
import {
  ChopAlterskategorie,
  ChopKatalog,
  ChopLeistungsgruppe,
  ChopMassnahme,
  ChopMesskriterium,
  ChopProfil,
  ChopProfilMassnahme,
} from '@entity/chop';
import { ChopService } from '@service/chop.service';

export interface ChopProfilDetailData {
  profil: ChopProfil;
  leistungsgruppe: ChopLeistungsgruppe;
  alterskategorie: ChopAlterskategorie;
  katalog: ChopKatalog;
  messkriterien: ChopMesskriterium[];
  profilMassnahmen: ChopProfilMassnahme[];
  allMassnahmen: ChopMassnahme[];
}

export const ChopProfilDetailResolve: ResolveFn<ChopProfilDetailData> = (route) => {
  const chopService = inject(ChopService);
  return chopService.getProfil(+route.params.profilId).pipe(
    switchMap((profil) =>
      forkJoin({
        leistungsgruppe: chopService.getLeistungsgruppe(profil.chopLeistungsgruppeId),
        messkriterien: chopService.getMesskriterien(profil.id),
        profilMassnahmen: chopService.getProfilMassnahmen(profil.id),
      }).pipe(
        switchMap((rest) =>
          chopService
            .getAlterskategorie(rest.leistungsgruppe.chopAlterskategorieId)
            .pipe(map((alterskategorie) => ({ ...rest, alterskategorie })))
        ),
        switchMap((rest) =>
          chopService
            .getKatalog(rest.alterskategorie.chopKatalogId)
            .pipe(map((katalog) => ({ profil, ...rest, katalog })))
        ),
        switchMap((rest) =>
          chopService.getMassnahmen(rest.katalog.jahr).pipe(map((allMassnahmen) => ({ ...rest, allMassnahmen })))
        )
      )
    )
  );
};
